<template>
  <SkeletonLoader v-if="!popupContent" type="image, article, actions" color="grey" :repeat="1" />
  
  <v-card
  v-else
  flat
  :class="`pa-0 ga-0 d-flex justify-center align-center flex-column flex-sm-${isFlipped ? 'row' : 'row-reverse'}`"
  color="secondary"
  rounded="lg"
  min-height="340px"
  >
  <a :href="popupContent.btn_1_href" target="_blank" :class="['w-100', hasTitleAndContent ? 'w-md-50' : 'w-md-100']">
    <div
    class="w-100 h-100"
    :style="imageStyles"
    ></div></a>
    <div v-if="hasTitleAndContent" class="w-100 w-md-50 pa-6 d-flex flex-column justify-center align-start">
      <h1 class="text-left info_title pb-0 lang_translate">{{ popupData.name }}</h1>
      <p class="text-left font-weight-thin lang_translate" v-html="popupContent.content"></p>
      <br />
      <Button
      :slim="true"
      version="action"
      :label="popupContent.btn_1_content"
      @click="navigateTo(popupContent.btn_1_href)"
      class="lang_translate"
      />
    </div>
  </v-card>
</template>

<script lang="ts" setup>
import { computed, ref, onMounted, watch } from 'vue';
import { getPopUpsForUser } from '@/services/admin_features/popupServices';

import Button from '@/components/ComponentLibrary/Button.vue';
import SkeletonLoader from '@/components/ComponentLibrary/SkeletonLoader.vue';

const popupData = ref<any>(null); // Initialize popupData to null to avoid errors before data is fetched
const popupContent = ref<any>(null); // Initialize popupContent to null to avoid errors before data is fetched
const isFlipped = ref(Math.random() < 0.5); // Randomly decide whether to flip the card

// Check for resize events to adjust the card layout
const windowWidth = ref(window.innerWidth);
window.addEventListener('resize', () => {
  windowWidth.value = window.innerWidth;
});

// Dynamic styles for the image background
const imageStyles = computed(() => ({
  backgroundImage: `url(${popupContent.value.img_url})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  minHeight: windowWidth.value < 600 ? '350px' : '400px',
}));

// Computed property to check if popupData and popupContent have the necessary properties
const hasTitleAndContent = computed(() =>
Boolean(popupData.value?.name?.trim()) &&
Boolean(popupContent.value?.content?.trim())
);

// Computed property to check if the popup has a button & open in new tab
const navigateTo = (href: string) => {
  if (href.startsWith('/')) {
    window.location.href = href;
  } else {
    window.open(href, '_blank');
  }
};

// Fetch popup data when the component is mounted
onMounted(async () => {
  
  // Get popups
  const res = await getPopUpsForUser();
  if (res?.data?.length) {
    popupData.value = res.data[0];
    popupContent.value = JSON.parse(JSON.parse(popupData.value.content));
  }
});

// Store the popup ID in localStorage when the popup is closed
defineExpose({
  onClose() {
    const id = popupData.value?.id;
    if (!id) return;
    
    const dismissedRaw = localStorage.getItem('dismissedPopups') || '{}';
    const dismissedMap: Record<number, string> = JSON.parse(dismissedRaw);
    dismissedMap[id] = new Date().toISOString();
    localStorage.setItem('dismissedPopups', JSON.stringify(dismissedMap));
  }
});

</script>

<style lang="scss">

</style>